import { keepPreviousData, queryOptions } from "@tanstack/react-query";
import { PessoaFiltrosCriteria } from "@workflow/types";

import { pessoaService } from "@/services/api/PessoaService";

const MINUTE = 1000 * 60;
const LIST_STALE = 30 * 1000;
const FILTROS_STALE = 30 * MINUTE;
const RESUMO_STALE = 60 * 1000;

/**
 * Query keys do domínio "pessoas". `list` é a key base invalidada após criar/editar
 * usuário, fazendo a grid server-side se refazer sozinha.
 */
export const pessoasKeys = {
  list: ["pessoas-listagem"] as const,
  filtros: ["pessoas-filtros"] as const,
  resumo: ["pessoas-resumo"] as const,
};

export const pessoasQueries = {
  list: (criteria: PessoaFiltrosCriteria) =>
    queryOptions({
      queryKey: [...pessoasKeys.list, criteria],
      queryFn: () => pessoaService.listPessoasPaginado(criteria),
      placeholderData: keepPreviousData,
      staleTime: LIST_STALE,
    }),

  filtros: () =>
    queryOptions({
      queryKey: pessoasKeys.filtros,
      queryFn: () => pessoaService.getPessoaFiltros(),
      staleTime: FILTROS_STALE,
    }),

  resumo: () =>
    queryOptions({
      queryKey: pessoasKeys.resumo,
      queryFn: () => pessoaService.getPessoaResumo(),
      staleTime: RESUMO_STALE,
    }),
};
